var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.19 12h-8.38C14.17 12 12 14.17 12 17.81v8.37c0 3.65 2.17 5.82 5.81 5.82h8.37c3.64 0 5.81-2.17 5.81-5.81v-8.38C32 14.17 29.83 12 26.19 12z",
    fill: "#FF5958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.58 29.25c-.41 0-.75-.34-.75-.75v-3.9c0-.41.34-.75.75-.75s.75.34.75.75v3.9c0 .41-.34.75-.75.75zM25.58 18.2c-.41 0-.75-.34-.75-.75V15.5c0-.41.34-.75.75-.75s.75.34.75.75v1.95c0 .41-.34.75-.75.75zM18.42 29.25c-.41 0-.75-.34-.75-.75v-1.95c0-.41.34-.75.75-.75s.75.34.75.75v1.95c0 .41-.33.75-.75.75zM18.42 20.15c-.41 0-.75-.34-.75-.75v-3.9c0-.41.34-.75.75-.75s.75.34.75.75v3.9c0 .41-.33.75-.75.75z",
    fill: "#FBEBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.58 17.33c-1.5 0-2.73 1.22-2.73 2.72 0 1.5 1.22 2.73 2.73 2.73 1.5 0 2.72-1.22 2.72-2.73s-1.22-2.72-2.72-2.72zM18.42 21.23c-1.5 0-2.72 1.22-2.72 2.73s1.22 2.72 2.72 2.72c1.5 0 2.73-1.22 2.73-2.72 0-1.5-1.22-2.73-2.73-2.73z",
    fill: "#FBEBE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkSettingsIcon);
export default __webpack_public_path__ + "static/media/bulkSettingsIcon.31556e39c18ef15fcc97296bdd8da9b6.svg";
export { ForwardRef as ReactComponent };